import watchForm from './watchForm';
import resetForm from './resetForm';
import events from './events';
import select from '../select';
import { activateLoginButtons } from '../facebook';

const setEventHandlers = ($form) => {
  const formEvents = events($form.attr('name'));
  if (typeof formEvents === 'object') {
    Object.keys(formEvents).forEach((event) => {
      $form.off(event).on(event, formEvents[event]);
    });
  }
  select();
  activateLoginButtons();
  $form.trigger('init', { target: $form[0] });
};

const prepopulateForm = ($form, data) => {
  Object.keys(data).forEach((key) => {
    let $input = $(`[name="${key}"]`, $form);
    if ($input.length === 0) {
      $input = $(`<input type="hidden" name="${key}"/>`).appendTo($form);
    }
    $input.val(data[key]);
  });
};

const activateForm = ($form, data = {}) => {
  resetForm($form);
  prepopulateForm($form, data);
  watchForm($form);
  setEventHandlers($form);
  return $form;
};

export default activateForm;
